'use client'
import * as React from 'react'
import dynamic from 'next/dynamic'
import { useIubendaTrackingAllowed } from '@repo/analytics/iubenda'
import { useIubendaConfig } from './iubenda'

const LazyLoadedClarity = dynamic(
  () => import('./clarity-script').then(m => ({ default: m.ClarityScript })),
  {
    ssr: false,
  },
)

interface ClarityProps {
  userId?: string
}

export const Clarity = ({ userId }: ClarityProps = {}) => {
  const { variant } = useIubendaConfig()
  const trackingAllowed = useIubendaTrackingAllowed(variant)
  const [addScript, setAddScript] = React.useState(false)

  //https://creativefabrica.atlassian.net/browse/GROWAA-198
  //The requirement is to add Clarity only if user comes from Bing
  //My account pages should be in clarity as well: https://creativefabrica.atlassian.net/browse/GROWTHMR-173
  React.useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      typeof document !== 'undefined' &&
      (document.referrer.includes('www.bing.com') ||
        window.location.pathname.includes('/my-account') ||
        window.location.pathname.includes('/b/'))
    ) {
      setAddScript(true)
    }
  }, [])

  return (
    addScript &&
    trackingAllowed && (
      <LazyLoadedClarity userId={userId} consentGranted={variant !== 'notApplicable'} />
    )
  )
}
